export enum DeviceProvider {
  APN = 'APN',
  FIREBASE = 'FIREBASE'
}
